import { render, staticRenderFns } from "./PlanUpgradeTooltip.vue?vue&type=template&id=053cf91a&scoped=true"
import script from "./PlanUpgradeTooltip.vue?vue&type=script&lang=js"
export * from "./PlanUpgradeTooltip.vue?vue&type=script&lang=js"
import style0 from "./PlanUpgradeTooltip.vue?vue&type=style&index=0&id=053cf91a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "053cf91a",
  null
  
)

export default component.exports